module.exports = __webpack_public_path__ + "img/shrink.42094b22.svg";